import axios, {AxiosInstance} from 'axios';

import {authInterceptor, errorInterceptor, getHeaders, HttpServiceError} from '../../api/apis';

import {settingsApi} from './settingsApi';

type HttpClientServiceInitProps = {
  client?: HttpClient;
  appEnv: 'test' | 'stage' | 'prod';
  onLoadSettingsFailed?: (reason?: any) => undefined;
  onUnAuthorizedCallback?: () => undefined | void;
  onError?: ((args: HttpServiceError) => void) | undefined;
};
class HttpClientService {
  private initPromiseResolve: (props: HttpClient) => void;

  private initPromiseFailed: (reason?: any) => void;

  private getHttpClientPromise: Promise<HttpClient> = new Promise<HttpClient>((resolve, reject) => {
    this.initPromiseResolve = resolve;
    this.initPromiseFailed = reject;
  });

  private initialized = false;

  async request<T>({requestParams, api}: {requestParams: RequestParams; api?: 'CUSTOMER' | 'PAYMENT' | 'WALLET'}) {
    const httpClient = await this.getHttpClientPromise;
    const standardHeaders = getHeaders();
    const baseURL = api ? await settingsApi.getApiURL({api}) : requestParams.baseURL;
    const request = {...requestParams, headers: {...requestParams.headers, ...standardHeaders}, baseURL};

    return httpClient.request<T>(request);
  }

  init(props: HttpClientServiceInitProps) {
    try {
      if (!this.initialized) {
        const {client = axios.create() as HttpClient, onUnAuthorizedCallback, onError} = props;

        if (onUnAuthorizedCallback) {
          authInterceptor(client as AxiosInstance, onUnAuthorizedCallback);
        }

        if (onError) {
          errorInterceptor(client as AxiosInstance, onError);
        }

        this.initialized = true;
        settingsApi.init({...props, client});
        this.initPromiseResolve(client);
      }
    } catch (ex) {
      this.initPromiseFailed(ex.message);
    }
  }

  getHttpClient = ({api}: {api: 'CUSTOMER' | 'PAYMENT' | 'WALLET'}): HttpClient => {
    return {
      request: async <T>(requestParams: RequestParams) => this.request<T>({requestParams, api}),
    };
  };
}

export const httpClientService = new HttpClientService();
